import { atom } from 'jotai';

import type { Selection } from 'react-aria-components';

/**
 * Atom to track selected inventory item IDs
 * Uses Selection type (Set<string> | 'all') for compatibility with Table component
 */
export const selectedInventoryIdsAtom = atom<Selection>(new Set<string>());

/**
 * Atom to track the current page items count
 * Used to calculate selected count when 'all' is selected
 */
export const currentPageItemsCountAtom = atom<number>(0);

/**
 * Action atom to update selected inventory items
 * Follows the same pattern as updateSelectedOrdersAtom
 */
export const updateSelectedInventoryAtom = atom(
	(get) => get(selectedInventoryIdsAtom),
	(get, set, newSelection: Selection) => {
		set(selectedInventoryIdsAtom, newSelection);
	},
);

/**
 * Action atom to clear all selections
 */
export const clearInventorySelectionAtom = atom(null, (_get, set) => {
	set(selectedInventoryIdsAtom, new Set());
});

/**
 * Derived atom that returns the count of selected items
 * When 'all' is selected, returns the current page items count
 */
export const selectedInventoryCountAtom = atom((get) => {
	const selection = get(selectedInventoryIdsAtom);
	if (selection === 'all') {
		// When 'all' is selected, it means all items on the current page
		return get(currentPageItemsCountAtom);
	}
	return selection.size;
});
